__turbopack_context__.v({
  "container": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__container",
  "description": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__description",
  "header": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__header",
  "progressTrack": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__progressTrack",
  "rateInput": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__rateInput",
  "slider": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__slider",
  "sliderInput": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__sliderInput",
  "sliderWrapper": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__sliderWrapper",
  "tickMarkActive": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__tickMarkActive",
  "title": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__title",
  "trackContainer": "FinanceQuoteTermSlider-module-scss-module__Xve4vG__trackContainer",
});
